<script setup>
import { markRaw } from "vue";
import { TableContainer, TableHeader } from "@easy/ui/tables";
import { CardEmpty, CardPreloader } from "@easy/ui/cards";
import { PageIcon } from "@easy/ui/icons";
import CertificateRow from "./CertificateRow.vue";
import cPagination from "@/shared/components/cPagination.vue";

defineProps({
    certs: {
        type: Array,
        default: () => [],
    },
    isLoading: {
        type: Boolean,
        default: false,
    },
    totalPages: {
        type: Number,
        required: true,
    },
    searchQuery: {
        type: String,
        default: "",
    },
});
const currentPage = defineModel("currentPage", { required: true });
defineEmits(["select"]);

const emptyIcon = markRaw(PageIcon);
</script>

<template>
    <div class="py-5 sm:p-6 space-y-6">
        <CardPreloader v-if="isLoading" />
        <CardEmpty
            v-else-if="!isLoading && !certs?.length"
            class="w-full ct-bg-1"
            :title="
                searchQuery
                    ? $t('player.panel.certificates.empty_when_search', { query: searchQuery })
                    : $t('player.panel.certificates.empty')
            "
            :icon="emptyIcon"
        />
        <TableContainer v-else>
            <template #headers>
                <tr>
                    <TableHeader>
                        {{ $t("player.panel.customer") }}
                    </TableHeader>
                    <TableHeader> Id </TableHeader>
                    <TableHeader sm-hidden>
                        {{ $t("player.panel.certificates.issued") }}
                    </TableHeader>
                    <TableHeader sm-hidden>
                        {{ $t("player.panel.certificates.link") }}
                    </TableHeader>
                </tr>
            </template>

            <template #body>
                <CertificateRow
                    :certificate="certificate"
                    v-for="certificate in certs"
                    :key="certificate.id"
                    @click="$emit('select', certificate)"
                />
            </template>
        </TableContainer>
        <cPagination v-model="currentPage" :totalPages="totalPages" />
    </div>
</template>
